import { useCallback, useEffect, useState } from "react";
import styleNtes from "./Notifications.module.scss";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from "../../../services/hooks.service";
import { ReactComponent as ICON } from '../../../assets/images/notifications.svg';
import classNames from "classnames";
import { errorHandler } from "../../../_utils/errorHandlers";
import { NotificationStatusEnum, NotificationTypeEnum } from "../../../interfaces";
// import { saveNotifications, saveNotificationsCount } from "../../../redux/_actions/system.action";
import { toast } from "react-toastify";
import { Loader } from "../Loader/Loader";
import { initialSystemNotificationsState, useGetNotificationsQuery, useReadNotificationsMutation } from "@ultrade/react-sdk";

export const Notifications = () => {
  const { t } = useTranslation();
  const isLogged = useIsLoggedSelector();
  // const dispatch = useAppDispatch();
  // const sdkClient = useAppSelector((state) => state.sdkClient.instance);
  // const notifications = useAppSelector((state) => state.system.notifications);
  // const count = useAppSelector((state) => state.system.notificationsUnreadCount);
  const [isOpen, setIsOpen] = useState(false);
  // const [isFirstLoad, setIsFirstLoad] = useState(true);
  // const [isLoading, setIsLoading] = useState(false);

  const [readNotifications] = useReadNotificationsMutation();
  const { data: { notifications, notificationsUnreadCount: count } = initialSystemNotificationsState, isLoading } = useGetNotificationsQuery(undefined);

  const openTab = () => setIsOpen(!isOpen);

  const getData = (data) => {
    const date = new Date(data);
    const monthName = date.toLocaleString('default', { month: 'short' });
    return `${monthName} ${date.getDate()}, ${date.getFullYear()}`;
  }

  const getDay = (data) =>  {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (new Date(data).valueOf() < today - 86400000) {
      return "";
    } else if (new Date(data).valueOf() < today) {
      return t("notifications.yesterday_txt");
    } else {
      return t("notifications.today_txt");
    }
  }

  const getBtn = (e) => {
    if (e.type === NotificationTypeEnum.GLOBAL_NEW_PAIR_LISTING) {
      return (
        <button className={styleNtes.not_btn} onClick={() => {}}>
          { t("notifications.view_listing") }
        </button>
      )
    }
    if (e.type === NotificationTypeEnum.GLOBAL_PAIR_DELISTING) {
      return (
        <button className={styleNtes.not_btn} onClick={() => {}}>
          { t("error_msg.cancel_orders") }
        </button>
      )
    }
    return <></>
  }

  const readAllNotifications = useCallback(async () => await readNotifications(notifications), [notifications, readNotifications]);

  // useEffect(() => {
  //   if (isOpen && isFirstLoad) {
  //     setIsLoading(true);
  //     sdkClient.getNotifications()
  //       .then(n => {
  //         dispatch(saveNotifications(n));
  //         setIsFirstLoad(false);
  //       })
  //       .catch(e => errorHandler(e))
  //       .finally(() => setIsLoading(false))
  //   }
  // }, [isOpen]);

  // useEffect(() => {
  //   sdkClient.getNotificationsUnreadCount()
  //     .then(n => dispatch(saveNotificationsCount(n.count)))
  //     .catch(e => console.log("Notifications count error: ", e))
  // }, []);

  return (
    <div className={styleNtes.notes_wrapper}>
      <button className={classNames(styleNtes.notes_btn, {[styleNtes.notes_active]: isOpen})} onClick={openTab}> 
        {!!count && <span className={styleNtes.notes_count}>
          { count > 99 ? "99+" : count }
        </span>}
        <ICON />
      </button>
      { isOpen && 
        <div className="black_dropdown_shadow" onClick={() => setIsOpen(false)}>
          <div className={styleNtes.filter_show} onClick={e => e.stopPropagation()}>
            <h6>{ t("notifications.notifications_txt") }</h6>
            <div className={styleNtes.not_cont}>
              { isLoading 
                ? <div className={styleNtes.table_loader}>
                    <Loader />
                  </div>
                : <> 
                  {notifications.map(e => (
                    <div key={e.id}
                      className={classNames(styleNtes.not_item, {[styleNtes.not_inem_unread]: e.status === NotificationStatusEnum.UNREAD})}
                    >
                      <p className={styleNtes.not_data}>
                        { getData(e.createdAt) }
                        <span className={styleNtes.gray_day}>
                          { getDay(e.createdAt) }
                        </span>
                      </p>
                      <p className={styleNtes.not_txt}>
                        { e.message }
                      </p>
                      {/* { getBtn(e) } */}
                    </div>
                  ))}
                </>
              } 
            </div>
            <button 
              disabled={!count} 
              className={classNames(styleNtes.read_not_btn, "transparent_btn")}
              onClick={readAllNotifications}
            >
              { t("notifications.mark_all_read") }
            </button>
          </div>
        </div>
      }
    </div>
  );
};
